import React, { useRef, useState } from 'react'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import {
  Card,
  Table,
  Button,
  Row, Col,
  Divider,
  Popconfirm
} from 'antd'

import { useDeepEffect } from '../../utils/hooks'
import _, { isEmpty } from 'lodash'
import CategoryEquipmentForm from './components/CategoryEquipment'
import SubEquipmentCategoryForm from './components/SubEquipmentCategoryForm'
import axios from 'axios'

const CategoryEquipment = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [visibleSubCategory, setVisibleSubCategory] = useState(false)
  const [formData, setFormData] = useState({})
  const [categories, setCategories] = useState([])
  const [formSubCategory, setFormSubCategory] = useState({})

  async function fetchCategories() {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/equipment/categoryDetail/all`
      )
      setCategories(res.data.data)
    } catch (err) {
      console.log(err)
    }
  }

  console.log(categories)

  async function updateCategory(data) {
    const token = localStorage.getItem('user-token')
    const authorizationHeader = token ? token : ''
    try {
      await axios.put(
        process.env.REACT_APP_API_ENDPOINT + `/equipment/updateCategory`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  async function createSubCategory(data) {
    const token = localStorage.getItem('user-token')
    const authorizationHeader = token ? token : ''
    try {
      await axios.post(
        process.env.REACT_APP_API_ENDPOINT + `/equipment/createSubCategory`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  async function updateSubCategory(data) {
    const token = localStorage.getItem('user-token')
    const authorizationHeader = token ? token : ''
    try {
      await axios.put(
        process.env.REACT_APP_API_ENDPOINT + `/equipment/updateSubCategory`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  async function deleteSubCategory(id) {
    const token = localStorage.getItem('user-token')
    const authorizationHeader = token ? token : ''
    try {
      await axios.delete(
        process.env.REACT_APP_API_ENDPOINT + `/equipment/subCategory/` + id, {
        headers: {
          Authorization: authorizationHeader
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  useDeepEffect(() => {
    fetchCategories()
  }, [])

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }
  const onCloseModal = async () => {
    await fetchCategories()
    await setVisible(false)
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await updateCategory(data)
    }
    await fetchCategories()
    await setVisible(false)
    await setFormData({})
  }

  async function onCickSubCategory(e, record) {
    e.preventDefault()
    setVisibleSubCategory(true)
    setFormSubCategory(record)
  }

  const onCloseSubModal = async () => {
    await fetchCategories()
    await setVisibleSubCategory(false)
  }

  const onSubOk = async (data) => {
    if (!_.isEmpty(formSubCategory)) {
      await updateSubCategory(data)
    } else {
      await createSubCategory(data)
    }
    await fetchCategories()
    await setVisibleSubCategory(false)
    await setFormSubCategory({})
  }

  const onSubDelete = async (id) => {
    await deleteSubCategory(id)
    await fetchCategories()
  }

  const HeaderSubCategory = () => {
    return (
      <Row type="flex" justify="space-between">
        <Col>
          <span>Equipment Category</span>
        </Col>
        <Col>
          <Button
            type="primary"
            onClick={(e) => onCickSubCategory(e)}>
            Add Sub Category
          </Button>
        </Col>
      </Row>
    )
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (name, row) => (
        <div>
          {row.image && (
            <img
              src={row.image}
              width={64}
              height={64}
              style={{ marginRight: 10, objectFit: 'cover' }}
            />
          )}
          {name}
        </div>
      )
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
        </span>
      )
    }
  ]

  const subColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (name, row) => (
        <div>
          {row.image && (
            <img
              src={row.image}
              width={64}
              height={64}
              style={{ marginRight: 10, objectFit: 'cover' }}
            />
          )}
          {name}
        </div>
      )
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onCickSubCategory(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onSubDelete(record.id)}
          >
            <Button
              type="danger"
              size="small"
              shape="circle"
              icon="delete"
            />
          </Popconfirm>
        </span>
      )
    }
  ]

  return (
    <Card title={HeaderSubCategory()}>
      <Table
        rowKey={(record) => record.id}
        bordered
        dataSource={categories}
        columns={columns}
        expandedRowRender={(record) => (
          <Card>
            <Table
              bordered
              dataSource={record.subEquipmentList}
              columns={subColumns}
            />
          </Card>
        )}
      />
      <CategoryEquipmentForm
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
        formData={formData}
      />
      <SubEquipmentCategoryForm
        visible={visibleSubCategory}
        onOk={onSubOk}
        onCancel={onCloseSubModal}
        formData={formSubCategory}
      />
    </Card>
  )
}

export default compose(
  withApollo
)(CategoryEquipment)


// WEBPACK FOOTER //
// ./src/pages/CategoryEquipment/index.js